import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DragCard from './DragCard'
import CardPlaceholder from './CardPlaceholder'
import throttle from 'lodash/throttle'
import find from 'lodash/find'
import { DropTarget } from 'react-dnd'
import { BOARD_DRAG_TYPES_CARD } from '../../../constants/boardDragTypes'
import AddCard from './AddCard'

function collectTarget(connector, monitor) {
  return {
    connectDropTarget: connector.dropTarget(),
    cardBeingDragged: monitor.getItem()
  }
}

const updatePosition = throttle(
  (props, monitor, component) => {
    let hasPassedOriginalPosition = false
    let hasPassedPlaceHolder = false
    const placeHolderHeight = component.props.cardBeingDragged ? component.props.cardBeingDragged.height : 0
    const cursorPosition = monitor.getClientOffset().y + props.scrollTop
    const nextCard = find(
      component.state.cardOffsets,
      card => {
        hasPassedPlaceHolder = hasPassedPlaceHolder || card.taskId === props.nextTaskId
        hasPassedOriginalPosition = hasPassedOriginalPosition || card.top === card.bottom

        let cardCenter = (card.top + card.bottom) / 2
        cardCenter -= hasPassedOriginalPosition ? placeHolderHeight : 0 // Card being dragged now has 0 height
        cardCenter += hasPassedPlaceHolder ? placeHolderHeight : 0 // Placeholder is pushing this card down
        return cardCenter > cursorPosition
      }
    )
    props.setPlaceHolder({
      laneId: props.laneId,
      nextTaskId: nextCard ? nextCard.taskId : null
    })
  },
  16,
  { leading: true, trailing: false }
)

const laneTarget = {
  hover(props, monitor, component) {
    updatePosition(props, monitor, component)
  }
}

class LaneBody extends Component {
  constructor(props) {
    super(props)
    this.state = {
      nextTaskId: null,
      cardOffsets: []
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.laneId !== nextProps.laneId ||
      this.props.tasks !== nextProps.tasks ||
      this.props.isOver !== nextProps.isOver ||
      this.props.nextTaskId !== nextProps.nextTaskId ||
      this.props.cardBeingDragged && !nextProps.cardBeingDragged ||
      this.state.cardOffsets !== nextState.cardOffsets
  }

  setTaskOffset = (taskId, offset, laneId) => {
    this.setState((prevState) => {
      const cardOffSets = prevState.cardOffsets.filter(cardOffset => cardOffset.taskId !== taskId)
      if (offset) {
        cardOffSets.push({
          top: offset.top + this.props.scrollTop,
          bottom: offset.bottom + this.props.scrollTop,
          taskId
        })
      }
      return {
        cardOffsets: cardOffSets.sort((a, b) => (a.bottom + a.top) - (b.bottom + b.top))
      }
    })
  }

  render() {
    const { connectDropTarget, cardBeingDragged } = this.props

    //Placeholder was getting drawn alongside the dropped task, causing bad task offsets
    let wasCardJustDroppedHere = cardBeingDragged
      && this.props.laneId !== cardBeingDragged.laneId
      && this.props.tasks.some(task => task.id === cardBeingDragged.task.id)

    return connectDropTarget(
      <div className='lane-body'>
        {this.props.isAddingTask &&
          (<AddCard
            onAddCancel={this.props.taskAddCancel}
            onAddSave={this.props.taskAddSave}
            laneId={this.props.laneId} />
          )
        }
        {this.props.tasks.map((task, index) => {
          return <div key={task.id}>
            {task.id === this.props.nextTaskId && cardBeingDragged && !wasCardJustDroppedHere &&
              <CardPlaceholder height={cardBeingDragged.height} />}
            <DragCard
              laneId={this.props.laneId}
              setPlaceHolder={this.props.setPlaceHolder}
              task={task}
              index={this.props.isAddingTask ? index : index + 1}
              onTaskDropped={this.props.onCardDrop}
              setTaskOffset={this.setTaskOffset} />
          </div>
        })}
        {this.props.isOver && this.props.nextTaskId === null && cardBeingDragged &&
          <CardPlaceholder height={cardBeingDragged.height} />
        }
      </div>
    )
  }
}

LaneBody.propTypes = {
  laneId: PropTypes.string.isRequired,
  tasks: PropTypes.array.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  onCardDrop: PropTypes.func.isRequired,
  isAddingTask: PropTypes.bool,
  taskAddCancel: PropTypes.func.isRequired,
  taskAddSave: PropTypes.func.isRequired,
  cardBeingDragged: PropTypes.object,
  scrollTop: PropTypes.number,
  setPlaceHolder: PropTypes.func.isRequired,
  nextTaskId: PropTypes.string
}

export default DropTarget(BOARD_DRAG_TYPES_CARD, laneTarget, collectTarget)(LaneBody)



// WEBPACK FOOTER //
// ./src/routes/Board/components/LaneBody.js